module.exports = __webpack_public_path__ + "img/obi-particles.368db35c.png";